interface FileExtensionToMimeTypeMap {
  [key: string]: string;
}

const fileExtensionToMimeTypeMap: FileExtensionToMimeTypeMap = {
  //===== audio =====
  flac: 'audio/x-flac',
  mp3: 'audio/mpeg',
  wav: 'audio/wave',
  xm: 'audio/x-mod',
  xmf: 'audio/mobile-xmf',

  //===== code =====
  c: 'text/x-csrc',
  cpp: 'text/x-c++src',
  css: 'text/css',
  rb: 'text/x-ruby',
  php: 'application/x-httpd-php',
  java: 'text/x-java-source',
  js: 'application/javascript',
  pl: 'application/x-perl',
  xml: 'application/xml',
  html: 'text/html',

  // === compression ===
  gz: 'application/gzip',
  tar: 'application/x-tar',
  zip: 'application/zip',

  //====== files=====
  csv: 'text/csv',
  doc: 'application/msword',
  docm: 'application/vnd.ms-word.document.macroenabled.12',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  dot: 'application/msword',
  dotm: 'application/vnd.ms-word.template.macroenabled.12',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  one: 'application/onenote',
  pdf: 'application/pdf',
  potm: 'application/vnd.ms-powerpoint.template.macroenabled.12',
  potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
  ppam: 'application/vnd.ms-powerpoint.addin.macroenabled.12',
  ppsm: 'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
  ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  pps: 'application/vnd.ms-powerpoint',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  rtf: 'application/rtf',
  tex: 'application/x-tex',
  tsv: 'text/tab-separated-values',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xltm: 'application/vnd.ms-excel.template.macroenabled.12',

  // ===== image ======
  bmp: 'image/bmp',
  gif: 'image/gif',
  ico: 'image/vnd.microsoft.icon',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  svg: 'image/svg+xml',
  tif: 'image/tiff',
  tiff: 'image/tiff',

  //===== video =====
  '3gp': 'video/3gpp',
  asf: 'video/x-ms-asf',
  avi: 'video/x-msvideo',
  m4v: 'video/x-m4v',
  mkv: 'video/x-matroska',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  mpeg: 'video/mpeg',
  mpg: 'video/mpeg',
  vob: 'video/mpeg',
  vorbis: 'audio/vorbis',
  webm: 'video/webm',
  wmv: 'video/x-ms-wmv',
};

type GetMimeTypeFromFileName = (fileName: string) => string;
export const getMimeTypeFromFileName: GetMimeTypeFromFileName = (fileName) => {
  const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

  return fileExtensionToMimeTypeMap[fileExtension] || '';
};
